import React, { Fragment, useEffect, useState } from "react";
import { Row,Collapse } from "reactstrap";
import { CardViewProjects,AddEditFormProject } from "../../projects/index";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import CardViewPreviousProjects from "../previousProjects/CardViewPreviousProjects";
import classnames from "classnames";
import { projectsList } from "../../../datas/projects";
import api from "../../../apis/api";
import {
  getProjectList,
  getProjectsOfEmployee,
  addProject,
  editProject,
  delProject,
} from "../../../redux/actions/projects/projects.action";

const TabProjects = React.memo(({ projectList, employeeId, empList, skillList }) => {
  const [activeTab, setActiveTab] = useState("currentproject");
  const [selectedProject, setSelectedProject] = useState(null);  
  const [isOpenAddEditForm, setIsOpenAddEditForm] = useState(false);
  const [isOpenProjectCardView, setIsOpenProjectCardView] = useState(true);
  const [isOpenProjectGridView, setIsOpenProjectGridView] = useState(false);
  const [isOpenSerachBox, setIsOpenSerachBox] = useState(false);
  const [error, setError] = useState(null);  
  const [searchArr, setSearchArr] = useState([]);
  const [employeeEditEnable,setEmployeeEditEnable] = useState(false);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  var loginUser = JSON.parse(localStorage.getItem("user"));
  let list=[];
  const [searchProjectArr, setSearchProjectArr] = useState([]);
  useEffect(() => {
    // console.log(employeeProjectList);
     // take not deleted projects, ie activeStatus === true.
     projectList.map((ListOfProjects, i) => {
     let filterOnlyActiveProject =  ListOfProjects.projectList.filter(
       (el) => el.activeStatus === true
     );
    
     // this.setState(searchArr);
     if(filterOnlyActiveProject != null)
     {
       list.push(filterOnlyActiveProject[0]);
     }
     setSearchProjectArr(list.filter( (ele, ind) => ind === list.findIndex( elem => elem.projectID === ele.projectID)));
   
     })
     
   }, [projectList]);
 // handle click in EmployeeCard.js
 const handleProjectEdit = React.useCallback(
  (project) => {
    setSelectedProject(project);
    setIsOpenAddEditForm((prevState) => !prevState);
    setIsOpenProjectCardView(false);
    setIsOpenProjectGridView(false);
  },
  [setIsOpenProjectCardView]
);
  // handle project delete.
  const handleDeleteProject = React.useCallback(
    (delId) => {
     // delProject(delId);
     api
     .project()
     .delProject(delId).then((res) => {
        if (res.status === 200) {
          
          fetchProjectList();
        } else {
          setError({
            ...error,
            message: "Bad Connection",
            status: 400,
          });
        }
      });
     // window.location = '/listProjects';
     
    },
    [delProject]
  );
  const fetchProjectList = () => {
    api
      .project()
      .getProjectsOfEmployee(loginUser.EmployeeId)
      .then((res) => {
        if (res.status === 200) {
          let filterOnlyActiveProject = res.data.filter(
            (el) => el.projectList[0].activeStatus === true);
            setSearchArr(filterOnlyActiveProject);

        } else {
          setError({
            ...error,
            message: "Bad Connection",
            status: 400,
          });
        }
      });
  };

   // handle click in EmployeeAddForm.js 'add'.
   const handleAddProject = React.useCallback(
    (projectData) => {
      //addProject(projectData);
      api
      .project()
      .addProject(projectData).then((res) => {
         if (res.status === 200) {
           
           fetchProjectList();
           setIsOpenAddEditForm(false);
           setIsOpenProjectCardView(true);
           setSelectedProject(null);
         } else {
           setError({
             ...error,
             message: "Bad Connection",
             status: 400,
           });
         }
       });
    },
    [addProject]
  );

   // handle click in AddEditFormProject.js 'update'.
   const handleUpdateProject = React.useCallback(
    (projectData) => {
     // console.log(projectData);
      // will get the selected project id from the selectedProject.
     // editProject(projectData);
     api
     .project()
     .editProject(projectData).then((res) => {
        if (res.status === 200) {
          
          fetchProjectList();
          setIsOpenAddEditForm(false);
          setIsOpenProjectCardView(true);
          setSelectedProject(null);
        } else {
          setError({
            ...error,
            message: "Bad Connection",
            status: 400,
          });
        }
      });
    },
    [editProject]
  );
  const toogleFromProjectAddEditForm = React.useCallback(() => {
    setIsOpenAddEditForm((prevState) => !prevState);
    setIsOpenProjectCardView((prevState) => !prevState);
    setSelectedProject("");
  }, [setIsOpenAddEditForm, setIsOpenProjectCardView]);

  return (
    <Fragment>
      <Nav tabs className="mt-2">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "currentproject" })}
            onClick={() => {
              toggle("currentproject");
            }}
          >
            Current Projects
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === "previousprojects",
            })}
            onClick={() => {
              toggle("previousprojects");
            }}
          >
            Previous Company Projects
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="mt-2">
        <TabPane tabId="currentproject">
        <Collapse isOpen={isOpenProjectCardView} className="mt-3">
          <Row className="project-box">
            <CardViewProjects 
              projectList={searchProjectArr}
              handleProjectEdit={handleProjectEdit}
              handleDeleteProject={handleDeleteProject}
              employeeEditEnable = {employeeEditEnable}
            ></CardViewProjects>        
          </Row>
          </Collapse>
        {/* Add & edit employee form.------------------------ */}
        <Collapse isOpen={isOpenAddEditForm}>
          <AddEditFormProject
            empList={empList}
            skillList={skillList}
            selectedProject={selectedProject}
            handleAddProject={handleAddProject}
            handleUpdateProject={handleUpdateProject}
            toogleFromProjectAddEditForm={toogleFromProjectAddEditForm}
            getProjectsOfEmployee={getProjectsOfEmployee}
          ></AddEditFormProject>
        </Collapse>
        </TabPane>
        <TabPane tabId="previousprojects">
          <Row className="project-box">
            <CardViewPreviousProjects employeeId={employeeId}>
              {" "}
            </CardViewPreviousProjects>
          </Row>
        </TabPane>
      </TabContent>
    </Fragment>
  );
});

export default TabProjects;
